// const developmentApi = "http://localhost:5002/api/v1";
// const developmentApi = "http://192.168.193.45:5002/api/v1"; //with zerotier
const productionApi = "https://api.dynamoedge.com/api/v1";

export default productionApi;
